<!-- 项目协议列表 -->
<template>
  <div class="choose-item">
    <ul v-if="agreeList.length">
      <li v-for="(item, index) in agreeList"
          :key="index"
          class="animated animatedFadeIn">
        <div class="choose-item-list">
          <h2>{{item.title}}</h2>
          <div class="bottom">
            <span>{{item.sendTime | filterTime}}</span>
            <a @click="handleMore(item)">查看更多</a>
          </div>
        </div>
      </li>
    </ul>
    <template v-else>
      <zlr-empty></zlr-empty>
    </template>
  </div>
</template>

<script>
// components
import ZlrEmpty from '_c/empty/empty'
// API
import { getAgreemenList } from '@/api/agreement'
import dayjs from 'dayjs'
export default {
  name: '',
  components: {
    ZlrEmpty
  },
  data () {
    return {
      agreeList: []
    }
  },
  computed: {},
  mounted () {
    this.getAgreeList()
  },
  methods: {
    // 获取协议列表
    getAgreeList () {
      getAgreemenList({}).then(res => {
        this.agreeList = res.data.model
      })
    },
    handleMore ({ id }) {
      this.$router.push({
        name: 'project-choose-agree',
        query: {
          id
        }
      })
    }
  },
  filters: {
    filterTime (value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang='less' scoped>
</style>
